var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if ($("#preloader").length > 0) {
  $("#preloader").hide();
  $("body").removeClass("preloader-overflow");
}
 
$(document).ready(function () {
    var Dwin = $(this); 
    if (Dwin.width() > 1024) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});
 
var resizeTimer;
$(window).on('resize', function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    var win = $(window); 
    if (win.width() > 1024) {
      slickVeritcal();
    } else {
      slickHorizontal();
    }    
  }, 100);
});

function slickVeritcal() {       
  if ($(".media-slick-slider  .thumbnail-list li").length > 6) {
  $(".thumbnail-list").not(".slick-initialized").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical:true,        
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [   
    {
      breakpoint: 1024,
      settings: {
        vertical: false,
      }
    },   
      {
      breakpoint: 1541,
      settings: {       
          slidesToShow: 3,
          slidesToScroll: 1
      }
    } 
    ]
  });

  }  
}
function slickHorizontal() {    
    if ($(".media-slick-slider  .thumbnail-list li").length > 5) {
      $(".thumbnail-list").slick("unslick");   
}
}

(function() {
  var isTicking = false;
  var $stickyBar = null;

  function updateStickyBar() {
    if (!$stickyBar || !$stickyBar.length) {
      $stickyBar = $(".sticky-bar");
    }
    if ($stickyBar && $stickyBar.length) {
      var w = $(window).width();
      var st = $(window).scrollTop();
      if ((w > 1024 && st >= 700) || (w <= 1024 && st >= 900)) {
        $stickyBar.addClass("active");
      } else {
        $stickyBar.removeClass("active");
      }
    }
    isTicking = false;
  }

  window.addEventListener('scroll', function() {
    if (!isTicking) {
      window.requestAnimationFrame(updateStickyBar);
      isTicking = true;
    }
  }, { passive: true });
})();

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });  
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};
if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}
if ($(".collection #AjaxinatePagination").length > 0) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  $('.facet-checkbox input:checkbox').each(function () {
  if($(this).is(':checked')){
       $(this).parent('.facet-checkbox').addClass('active');
    }     
  });
hotSpot();  
cardSwatch();
  
  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }



  $(".custom-product-grid li").click(function () {
    var classNames ="list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
    var getCols = $(this).data("cols");
    var getVal = $(this).data("val");
    var getVal = "align-"+getVal+"-column";    
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols+" "+getVal);
  });
  if ($(".filter-buttons").length > 0) {
    const viewExists = document.querySelector(".grid-view-button");
    if (viewExists.classList.contains("layout-mode")) {
      const listViewButton = document.querySelector(".list-view-button");
      const gridViewButton = document.querySelector(".grid-view-button");
      const list = document.querySelector("ul.view-mode");
      const gridviewlist = document.querySelector(".custom-product-grid");

      listViewButton.onclick = function () {
        listViewButton.classList.add("active");
        gridViewButton.classList.remove("active");
        list.classList.remove("grid-view-filter");
        list.classList.add("list-view-filter");
        gridviewlist.classList.add("hidden");
      };

      gridViewButton.onclick = function () {
        listViewButton.classList.remove("active");
        gridViewButton.classList.add("active");
        list.classList.remove("list-view-filter");
        list.classList.add("grid-view-filter");
        gridviewlist.classList.remove("hidden");
      };
    }
  }
  if ($("#swiper-sidebar-carousel").length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  setTimeout(function () {
    $(".loading-image").removeClass("loading-image").addClass("loaded-image");
  }, 2000);

  const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
  const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
  var selectedRadioButton;
  for (const radioButton of radioButtons) {
    if (radioButton.checked) {
      selectedRadioButton = radioButton.getAttribute("data-value");      
      optionSummary.innerHTML = selectedRadioButton;    
    }
  }
  
}

// function cardSwatch() {
//    // Item swatch trigger start
// $("body").on("click", ".color-values a", function(event) {
//   console.log(event.target); 
//   var $colorLinks = $(this).closest('.variant-option-color').find('.color-values a');
//   $colorLinks.removeClass("active");
//   $(this).addClass("active");
// });


// $("body").on("click", ".size-values a", function () {
//     $(".size-values a").removeClass("active");
//     $(this).addClass("active");
// });

// $("body").on("click", ".color-values-plus a", function (e) {
//     e.preventDefault();
//     $(this).parents(".variant-option-color").find(".show-on-click").css("display", "flex");
//     $(this).parents(".color-values-plus").css("display", "none");
// });

// $("body").on("click", ".swatch span", function (eventDT) {     
//     var $cardWrapper = $(this).parents(".card-wrapper");
//     var $motionReduce = $cardWrapper.find(".card__inner .motion-reduce");
//     var imageUrl = $(this).data("image");

//     $motionReduce.attr("srcset", imageUrl);

//     if ($(this).parents(".swatch").hasClass("color")) {
//         var variant = $(this).data("id");
//         $(this).parents(".product-grid").find(".variant-push").val(variant);

//         var swatchItem = $(this).data("variant-item");

//         $(this).parents(".product-grid").find(".variant-option-size .size-values").removeClass("active");

//         $(this).parents(".product-grid").find(".variant-option-size .swatch").each(function () {
//             var swatchSizeVars = $(this).find("span").data("variant-title").split("/").map($.trim).map(function (n) {
//                 return n.toLowerCase().replace(/ /g, "-");
//             });

//             if ($.inArray(swatchItem, swatchSizeVars) >= 0) {
//                 $(this).parent(".size-values").toggleClass("active");
//             }
//         });
//     }

//     if ($(this).parents(".swatch").hasClass("size")) {
//         var variant = $(this).data("id");
//         $(this).parents(".product-grid").find(".variant-push").val(variant);
//     }
// });
// // Item swatch trigger end
   
// }
function cardSwatch() {
   // Item swatch trigger start
   $("body").on("click", ".color-values a", function(event) {
     var $colorLinks = $(this).closest('.variant-option-color').find('.color-values a');
     $colorLinks.removeClass("active");
     $(this).addClass("active");
   });

   $("body").on("click", ".size-values a", function () {
       $(".size-values a").removeClass("active");
       $(this).addClass("active");
   });

   $("body").on("click", ".color-values-plus a", function () {
       $(this).parents(".variant-option-color").find(".show-on-click").css("display", "flex");
       $(this).parents(".color-values-plus").css("display", "none");
   });

   $("body").on("click", ".swatch span", function (eventDT) {     
       var $cardWrapper = $(this).parents(".card-wrapper");
       var $motionReduce = $cardWrapper.find(".card__inner .motion-reduce");
       var imageUrl = $(this).data("image");

       $motionReduce.attr("srcset", imageUrl);

       if ($(this).parents(".swatch").hasClass("color")) {
           var variant = $(this).data("id");
           $(this).parents(".product-grid").find(".variant-push").val(variant);

           var swatchItem = $(this).data("variant-item");

           $(this).parents(".product-grid").find(".variant-option-size .size-values").removeClass("active");

           $(this).parents(".product-grid").find(".variant-option-size .swatch").each(function () {
               var swatchSizeVars = $(this).find("span").data("variant-title").split("/").map($.trim).map(function (n) {
                   return n.toLowerCase().replace(/ /g, "-");
               });

               if ($.inArray(swatchItem, swatchSizeVars) >= 0) {
                   $(this).parent(".size-values").toggleClass("active");
               }
           });
       }

       if ($(this).parents(".swatch").hasClass("size")) {
           var variant = $(this).data("id");
           $(this).parents(".product-grid").find(".variant-push").val(variant);
       }
   });
   // Item swatch trigger end
}

//FBT ul li select box
$("ul.custom-select").on("click", "li:not(.init)", function () {
  var selectedVal = $(this).data("option-value");  
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option")
    .attr("selected", false);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option[value=" + selectedVal + "]")
    .attr("selected", "selected")
    .trigger("change");
});

$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html());
  $(this).parent().children(".init").removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) {
    $("#add-frequently-bought").prop("disabled", true);
  } else {
    $("#add-frequently-bought").prop("disabled", false);
  }
});
loadedBg();
function loadedBg() {
  window.onload = function () {
    setTimeout(function () {
      $(".loading-image").removeClass("loading-image").addClass("loaded-image");
    }, 3000);
  };
}

jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});


document.querySelector(".header-drawer__close").addEventListener("click", closeDrawerMenu);
function closeDrawerMenu() {
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
}

$("#dT_TopStickySearchBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").addClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "1");
  $("body").addClass("search-overlay-open");
});

$(".dT_TopStickySearchCloseBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").removeClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "0");
  $("body").removeClass("search-overlay-open");
});

$(document).ready(function () {
  if (document.querySelector("#AccessibleNav .sub-menu-block")) {
    $("#AccessibleNav .sub-menu-block").show();
  }
  var mainEl = document.getElementById("MainContent");
  if (mainEl) {
    mainEl.classList.remove("placeholder-shadow-blocks");
  }
});



$(function() {
  $('.acc__title').click(function(j) {    
    var dropDown = $(this).closest('.dt-sc-tabs-content');
    $(this).closest('dt-sc-tabs-content').not(dropDown).slideUp();    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('dt-sc-tabs-content.active').removeClass('active');
      $(this).addClass('active');
    }    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});


$(document).ready(function(){ 
    $('.tablinks').click(function(){  
      $(".dt-sc-tabs-content").removeClass('tab-active-content');
      $(".dt-sc-tabs-content[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active-content");
      $(".tablinks").removeClass('active-tab');     
      $(this).addClass('active-tab');
     });
});



// $(document).ready(function() {
//   $('.dt-sc-hotspot-marker').on('click', function() {   
//     $('.dt-sc-hotspot-popup').hide();
//     const targetPopup = $(this).data('target');
//     $('#' + targetPopup).show();
//   });
//   $(document).on('click', function(event) {
//     if (!$(event.target).closest('.dt-sc-hotspot-marker, .dt-sc-hotspot-popup').length) {
//       $('.dt-sc-hotspot-popup').hide();
//     }
//   });
// });



$(document).ready(function () {
    hotSpot();  
});
$(window).on("resize", function () {
    hotSpot();  
});

function hotSpot() {
    if ($(window).width() > 250) {
        if ($('.tool-tip-style-1').length > 0) {
            $('.dt-sc-hotspot-item').each(function () {
                var $pop = $(this).find('.dt-sc-hotspot-popup');
                $pop.click(function (e) {
                   e.stopPropagation();
                   e.stopImmediatePropagation();
                });

                $(this).find('a.dt-sc-hotspot-marker').click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var $thisHotspot = $(this).parent().parent();
                    $thisHotspot.addClass('this-hotspot-in-active');

                    if ($(this).hasClass("clicked")) {
                        $(this).removeClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'none'});
                        $('.dt-sc-hotspot-item').removeClass('open');
                        $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'none'});                      
                    } else {
                        $(this).addClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'auto'});
                        $(this).parent().addClass('open');
                        $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
                        $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
                    }
                 
                });

                $(document).click(function () {
                    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
                    $pop.removeClass('dt-sc-popup-open');
                    $('.dt-sc-hotspot-item').removeClass('open');
                    $('a.dt-sc-hotspot-marker').removeClass('clicked');
                    $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                });
            });
        }

        if ($('.tool-tip-style-3').length > 0) {
            $('.dt-sc-hotspot-item').each(function () {
                var $pop = $(this).find('.dt-sc-hotspot-popup');
                $pop.hover(function (e) {
                   e.stopPropagation();
                });

                $(this).find('a.dt-sc-hotspot-marker').hover(function (e) {
                   e.preventDefault();
                   e.stopPropagation();

                    var $thisHotspot = $(this).parent().parent();
                    $thisHotspot.addClass('this-hotspot-in-active');

                    if ($(this).hasClass("clicked")) {
                        $(this).removeClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'auto'});
                        $('.dt-sc-hotspot-item').removeClass('open');
                        $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                    } else {
                        $(this).addClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'auto'});
                        $(this).parent().addClass('open');
                        $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
                        $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
                    }
                });

                $(this).find('a.dt-sc-hotspot-marker').mouseout(function (e) {
                    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
                    $pop.removeClass('dt-sc-popup-open');
                    $('.dt-sc-hotspot-item').removeClass('open');
                    $('a.dt-sc-hotspot-marker').removeClass('clicked');
                    $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                });

                $(document).click(function () {
                    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
                    $pop.removeClass('dt-sc-popup-open');
                    $('.dt-sc-hotspot-item').removeClass('open');
                    $('a.dt-sc-hotspot-marker').removeClass('clicked');
                    $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                });
            });
        }
    }

    if ($(window).width() < 251) {
        $('.dt-sc-hotspot-popup').addClass('mfp-hide');
        $('.dt-sc-hotspot-marker').each(function () {
            $(this).magnificPopup({
                type: 'inline',
                closeOnBgClick: true,
                closeBtnInside: false,
                showCloseBtn: true
            });
        });
    }
}

function makeTimer() {

  $('.product-deal-count').each(function() {
   
    var endTime = new Date($(this).attr('data-end-time'));		
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    
    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }
      $(this).find(".days").html(days + "<span>"+window.deals.days+"</span>");
      $(this).find(".hours").html(hours + "<span>"+window.deals.hours+"</span>");
      $(this).find(".minutes").html(minutes + "<span>"+window.deals.minutes+"</span>");
      $(this).find(".seconds").html(seconds + "<span>"+window.deals.seconds+"</span>");
      
    } else {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
    }
    
  });

}

if (document.querySelector('.product-deal-count')) {
  setInterval(function() { makeTimer(); }, 1000);
}





